module.exports = __webpack_public_path__ + "static/media/lucky_border2.aa00dff4.png";